import { useState } from 'react';
import { ParcellingPage } from '@practium/features/parcelling';
import { UserRole } from '@practium/shared';
import { useAuth } from '@practium/features/auth';
import { usePermissions } from '@practium/features/permissions';
import { useAdminParcellingPage } from '../hooks/useAdminParcellingPage';

const PARCELLING_PAGE_SIZE = 15;

export const ParcellingPageAdmin = () => {
	const { user } = useAuth();
	const [listPage, setListPage] = useState(1);
	const { abilities } = usePermissions();

	const canRead = abilities.can('read', 'parcelling');
	const canCreate = abilities.can('create', 'parcelling');
	const canEdit = abilities.can('update', 'parcelling');
	const canDelete = abilities.can('delete', 'parcelling');

	const permissions = {
		canView: canRead,
		canCreate,
		canEdit,
		canDelete,
		canDuplicate: canEdit,
		canExport: canRead,
	};

	const { mockData, fetchFarms, fetchBindingUsers } = useAdminParcellingPage({
		page: listPage,
		limit: PARCELLING_PAGE_SIZE,
	});

	return (
		<ParcellingPage
			config={{
				permissions,
				mockData,
				userRole: UserRole.Admin,
				currentUserId: user?._id || '',
				isMaster: user?.isMaster ?? true,
			}}
			page={listPage}
			onPageChange={setListPage}
			fetchBindingUsers={fetchBindingUsers}
			fetchFarms={fetchFarms}
		/>
	);
};
